/* eslint no-console: "off", quotes: "off" */
import { mapState, mapGetters, mapMutations } from "vuex";

export const ParseResponseMixin = {
  methods: {
    parseServerResponse(responseBody) {
      let parsedResponse = null;
      try {
        console.log('Parsing server response...');
        parsedResponse = JSON.parse(responseBody);
      } catch (error) {
        console.error(`Failed to parse server response with the following error: ${error}`);
      }
      return parsedResponse;
    },
  },
};

// game mixin object (shared between ResumingGame and Game components)
export const GameMixin = {
  watch: {
    stompClient: {
      handler() {
        console.log('change to stompclient!');
        // eslint-disable-next-line
        console.log('connected: ' + this.stompClient.connected);
        if (!this.stompClient.connected && !this.isResume) this.stompFailure('lock screen error');
      },
      deep: true,
    },
  },
  data() {
    return {
      playerAnswered: false,
      bothPlayersAnswered: false,
    };
  },
  methods: {
    ...mapMutations('game', [
      'setCurrentRoundNumber',
      'setCurrentQuestionNumber',
      'setHomePlayerAnswer',
      'setAwayPlayerAnswer',
      'setCorrectAnswerID',
      'updatePlayersAnswersHistoryCSSClasses',
      'setPlayersCurrentQuestionDTOs',
      'setPlayersHelpsUsedStatus',
      'setHomePlayerRoundAnswerTime',
      'setAwayPlayerRoundAnswerTime',
      'setPlayersCurrentRoundScores',
      'setCurrentRoundWinner',
      'setPlayersCurrentThemes',
      'setGameFinishedStatus',
      'setGameWinner',
      'setUserLeveledUp',
      'setPlayersPostGameData',
      'setUserSpinWheelInfo',
      'setHomeCorrectAnswers',
      'setAwayCorrectAnswers',
    ]),
    ...mapMutations('common', [
      'storeUserLevel',
      'storeUserAvailableGames',
    ]),
    updatePlayersAnswersHistory(responseData) {
      console.log('this.currentRoundNumber:', this.currentRoundNumber);
      console.log('this.currentQuestionNumber:', this.currentQuestionNumber);
      // set the answers history (small circles) for both players
      const homePlayerCurrentRoundHistory = responseData.homeUserDetails.roundDTOList[this.currentRoundNumber - 1].answerDTOList;
      const awayPlayerCurrentRoundHistory = responseData.awayUserDetails.roundDTOList[this.currentRoundNumber - 1].answerDTOList;
      this.updatePlayersAnswersHistoryCSSClasses({
        homePlayerCorrectAnswersCSSClasses: homePlayerCurrentRoundHistory.map(answerDTO => (answerDTO.correct ? 'correct' : 'wrong')),
        awayPlayerCorrectAnswersCSSClasses: awayPlayerCurrentRoundHistory.map(answerDTO => (answerDTO.correct ? 'correct' : 'wrong')),
      });
      this.setHomeCorrectAnswers(this.homePlayerCorrectAnswersCSSClasses.filter(item => item === 'correct').length);
      this.setAwayCorrectAnswers(this.awayPlayerCorrectAnswersCSSClasses.filter(item => item === 'correct').length);
    },
    saveRoundTotalAnswerTime(responseData) {
      this.setHomePlayerRoundAnswerTime(responseData.homeUserDetails.roundDTOList[this.currentRoundNumber - 1].totalAnswerTimeMillis);
      this.setAwayPlayerRoundAnswerTime(responseData.awayUserDetails.roundDTOList[this.currentRoundNumber - 1].totalAnswerTimeMillis);
    },
    saveQuestionNumber(responseData) {
      this.setCurrentQuestionNumber(responseData.homeUserDetails.roundDTOList[this.currentRoundNumber - 1].answerDTOList.length);
      console.log('this.currentQuestionNumber:', this.currentQuestionNumber);
    },
    saveQuestionDataForNextQuestion(responseData) {
      // set questionDTOs for next question
      this.setPlayersCurrentQuestionDTOs({
        homePlayerQuestionDTO: responseData.homeUserDetails.questionDTO,
        awayPlayerQuestionDTO: responseData.awayUserDetails.questionDTO,
      });
    },
    saveQuestionData(responseData) {
      this.setCurrentRoundNumber(responseData.homeUserDetails.roundDTOList.length);
      console.log('this.currentRoundNumber:', this.currentRoundNumber);
      this.setCurrentQuestionNumber(responseData.homeUserDetails.roundDTOList[this.currentRoundNumber - 1].answerDTOList.length);
      console.log('this.currentQuestionNumber:', this.currentQuestionNumber);

      this.setHomePlayerAnswer(responseData.homeUserDetails.roundDTOList[this.currentRoundNumber - 1].answerDTOList[this.currentQuestionNumber - 1].answerKey);
      this.setAwayPlayerAnswer(responseData.awayUserDetails.roundDTOList[this.currentRoundNumber - 1].answerDTOList[this.currentQuestionNumber - 1].answerKey);
      console.log('setting home player answer to :', this.homePlayerAnswer);
      console.log('setting away player answer to :', this.awayPlayerAnswer);

      this.setCorrectAnswerID(responseData.previousCorrectAnswerId);

      this.updatePlayersAnswersHistory(responseData);

      // in the case of auto select answer from the server set playerAnswered to true
      // in order to block user from selecting another answer
      this.playerAnswered = true;
      this.bothPlayersAnswered = true;

      this.setPlayersHelpsUsedStatus({
        homePlayerCheatHelpUsed: responseData.homeUserDetails.cheatUsed,
        homePlayerFiftyFiftyHelpUsed: responseData.homeUserDetails.fiftyFiftyUsed,
        awayPlayerCheatHelpUsed: responseData.awayUserDetails.cheatUsed,
        awayPlayerFiftyFiftyHelpUsed: responseData.awayUserDetails.fiftyFiftyUsed,
      });
    },
    saveRoundData(responseData) {
      const homePlayerResponseData = responseData.homeUserDetails;
      const awayPlayerResponseData = responseData.awayUserDetails;

      console.log('this.gameIsResuming:', this.gameIsResuming);
      if (!this.gameIsResuming) {
        if (this.isHomePlayer) {
          this.setAwayPlayerAnswer(awayPlayerResponseData.roundDTOList[this.currentRoundNumber - 1].answerDTOList[this.currentQuestionNumber - 1].answerKey);
        } else {
          this.setHomePlayerAnswer(homePlayerResponseData.roundDTOList[this.currentRoundNumber - 1].answerDTOList[this.currentQuestionNumber - 1].answerKey);
        }

        this.saveRoundTotalAnswerTime(responseData);
      }

      this.setPlayersCurrentRoundScores({
        homePlayerRoundScore: homePlayerResponseData.score,
        awayPlayerRoundScore: awayPlayerResponseData.score,
      });

      this.setCurrentRoundWinner({
        isHomePlayerWinner: homePlayerResponseData.roundDTOList[this.currentRoundNumber - 1].isWinner,
        isAwayPlayerWinner: awayPlayerResponseData.roundDTOList[this.currentRoundNumber - 1].isWinner,
      });

      this.updatePlayersAnswersHistory(responseData);
      this.saveRoundTotalAnswerTime(responseData);

      this.setPlayersCurrentThemes({
        homePlayerCurrentThemes: homePlayerResponseData.themeDTOList,
        awayPlayerCurrentThemes: awayPlayerResponseData.themeDTOList,
      });

      if (responseData.gameStateEnum === 'GAME_FINISHED') {
        console.log('responseData.gameStateEnum === GAME_FINISHED');
        this.storePostGameData(responseData);
      }
      this.bothPlayersAnswered = true;
    },
    storePostGameData(responseData) {
      const userLeveledUp = this.isHomePlayer ? responseData.homeUserDetails.levelUp : responseData.awayUserDetails.levelUp;
      this.setUserLeveledUp(userLeveledUp);
      if (userLeveledUp) {
        this.storeUserLevel(this.isHomePlayer ? responseData.homeUserDetails.currentLevel : responseData.awayUserDetails.currentLevel);
      }
      const spinWheelInfo = {
        hasWon: this.isHomePlayer ? responseData.homeUserDetails.prizeWon : responseData.awayUserDetails.prizeWon,
        showSpinWheel: this.isHomePlayer ? responseData.homeUserDetails.prizeNotification : responseData.awayUserDetails.prizeNotification,
        prizeName: this.isHomePlayer ? responseData.homeUserDetails.prizeWonDesc : responseData.awayUserDetails.prizeWonDesc,
        correlationId: responseData.gameId, // correlationId doesn't always have value, so we use game id to fetch appropriate spin wheel notification
      };
      this.setUserSpinWheelInfo(spinWheelInfo);
      this.setGameFinishedStatus(true);
      this.setGameWinner({
        gameWinnerMSISDN: responseData.winnerHome ? this.playersDetails.homePlayerMSISDN : this.playersDetails.awayPlayerMSISDN,
        gameWinnerUsername: responseData.winnerHome ? this.playersDetails.homePlayerUsername : this.playersDetails.awayPlayerUsername,
      });
      this.storeUserAvailableGames({ availableGames: this.isHomePlayer ? responseData.homeUserDetails.currentAvailableGames : responseData.awayUserDetails.currentAvailableGames });
      console.log('this.userDetails.availableGames', this.userDetails.availableGames);
      this.setPlayersPostGameData({
        homePlayerCorrectAnswersPoints: responseData.homeUserDetails.postgamePointsFromCorrectAnswers,
        homePlayerRoundVictoriesPoints: responseData.homeUserDetails.postgamePointsFromRoundsWon,
        homePlayerGameVictoryPoints: responseData.homeUserDetails.postgamePointsFromGameWon,
        homePlayerTotalEarnedPoints: responseData.homeUserDetails.postgamePointsTotal,
        homePlayerLevelUpBonusPoints: responseData.homeUserDetails.levelUpPoints,
        homePlayerCurrentLevel: responseData.homeUserDetails.currentLevel,
        homePlayerGameWinsToLevelUp: responseData.homeUserDetails.gamesToNextLevel,
        homePlayerGamesWon: responseData.homeUserDetails.currentLevelGamesWon,
        homePlayerGamesEarned: responseData.homeUserDetails.levelUpGames,
        homePlayerLevel: responseData.homeUserDetails.level,
        awayPlayerCorrectAnswersPoints: responseData.awayUserDetails.postgamePointsFromCorrectAnswers,
        awayPlayerRoundVictoriesPoints: responseData.awayUserDetails.postgamePointsFromRoundsWon,
        awayPlayerGameVictoryPoints: responseData.awayUserDetails.postgamePointsFromGameWon,
        awayPlayerTotalEarnedPoints: responseData.awayUserDetails.postgamePointsTotal,
        awayPlayerLevelUpBonusPoints: responseData.awayUserDetails.levelUpPoints,
        awayPlayerCurrentLevel: responseData.awayUserDetails.currentLevel,
        awayPlayerGameWinsToLevelUp: responseData.awayUserDetails.gamesToNextLevel,
        awayPlayerGamesWon: responseData.awayUserDetails.currentLevelGamesWon,
        awayPlayerGamesEarned: responseData.awayUserDetails.levelUpGames,
        awayPlayerLevel: responseData.awayUserDetails.level,
      });
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapState('game', [
      'gameIsResuming',
      'playersDetails',
      'currentRoundNumber',
      'currentQuestionNumber',
      'homePlayerAnswer',
      'homePlayerRoundScore',
      'homePlayerQuestionDTO',
      'homePlayerCheatHelpUsed',
      'homePlayerFiftyFiftyHelpUsed',
      'homePlayerCorrectAnswersCSSClasses',
      'awayPlayerAnswer',
      'awayPlayerRoundScore',
      'awayPlayerQuestionDTO',
      'awayPlayerCheatHelpUsed',
      'awayPlayerFiftyFiftyHelpUsed',
      'awayPlayerCorrectAnswersCSSClasses',
    ]),
    ...mapGetters('game', [
      'isHomePlayer',
    ]),
  },
};

// game mixin object 2 (shared between all game components and is used for flow control,
// when we press the back or forward browser buttons or refresh the page)
export const GameMixin2 = {
  data() {
    return {
      normalTransition: false,
    };
  },
  methods: {
    ...mapMutations('game', [
      'setTransitionOnlyForSearchingToOpponent',
    ]),
  },
  beforeRouteEnter(to, from, next) {
    console.log('==> inside component\'s beforeRouteEnter:');
    console.log(`from.path: ${from.path}`);
    console.log(`to.path: ${to.path}`);
    // the page have must been refreshed, redirect to home page
    if (from.path === '/') {
      next({ path: '/home' });
    }
    next();
  },
  beforeRouteLeave(to, from, next) {
    console.log('==> inside component\'s beforeRouteLeave:');
    console.log(`from.path: ${from.path}`);
    console.log(`to.path: ${to.path}`);
    console.log('this.normalTransition:');
    console.log(this.normalTransition);
    if (this.transitionOnlyForSearchingToOpponent && (from.path === '/searchingOpponent' && to.path === '/opponentFound')) {
      console.log('User tries again for the same Game to play a game, so navigate him to Opponent Found and not HOME');
      this.normalTransition = true;
      this.setTransitionOnlyForSearchingToOpponent(false);
      next();
    }
    if (!this.normalTransition) {
      this.normalTransition = true;
      console.log('going to home');
      next({ path: '/home' });
    }
    next();
  },
  computed: {
    ...mapState('game', [
      'transitionOnlyForSearchingToOpponent',
    ]),
  },
};

export const GameMixin3 = {
  beforeDestroy() {
    console.log(`in ${this.$options.name} beforeDestroy hook`);
    console.log('this.subscription', this.subscription);
    // if for any reason we leave this component earlier from the websocket's response,
    // unsubscribe from the subscribed channel
    this.subscription.unsubscribe();
    if (this.timer !== undefined || this.timer !== null) {
      clearInterval(this.timer);
    }
  },
};



// WEBPACK FOOTER //
// ./src/common/mixins/game.js